import React, { useEffect, useState } from 'react';
import { FolderAddFilled, LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import { Flex, Image, message, Upload } from 'antd';
import ImageService from "services/image";
const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
};

const App = ({ value, onChange }) => {
    const [loading, setLoading] = useState(false);
    const [imageUrl, setImageUrl] = useState();
    useEffect(() => {
        if (value) {
            setImageUrl(value.url)
        } else {
            setImageUrl(null);
        }

    }, [value])


    const handleChange = info => {
        if (info.file.status === 'uploading') {
            setLoading(true);
            return;
        }
        if (info.file.status === 'done') {
            // Get this url from response in real world.
            getBase64(info.file.originFileObj, url => {
                setLoading(false);
                setImageUrl(url);
            });
        }
    };
    const uploadButton = (
        <button style={{ border: 0, background: 'none' }} type="button">
            {loading ? <LoadingOutlined /> : <PlusOutlined />}
            <div style={{ marginTop: 8 }}>Upload</div>
        </button>
    );
    const beforeUpload = async (file) => {
        setLoading(true);
        const saved = await uploadImage(file);
        onChange(saved)
        setLoading(false)

    }

    const uploadImage = async (file) => {
        const imageService = new ImageService();
        try {
            const formData = new FormData();
            formData.append("file", file);

            const result = await imageService.uploadLogo(formData);
            return result;
        } catch (error) {
            error("File  was not uploaded. Please try again later");
            throw error;
        }
    };

    return (
    
            <Upload
                name="avatar"
                listType="picture-card"
                className="avatar-uploader"
                showUploadList={false}
   
                action={beforeUpload}
                onChange={handleChange}
                loading={loading}
            >
                {imageUrl ? <img src={imageUrl} alt="avatar" style={{ width: 100, height:100, objectFit:"contain" }} /> : uploadButton}
            </Upload>

       
    );
};
export default App;